var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upgrader"},[_c('UpgraderGame'),_c('UpgraderItems')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }